import React, {useEffect, useRef, useState} from 'react';
import "./SlideShow.sass";
import _ from 'lodash';
import gsap from "gsap";

const SlideShow = ({data, selectedSlide}) => {
        const {loop, mode, delay, style, id, slides} = data;
        const [slideIndex, setSlideIndex] = useState(0);
        const [previousIndex, setPreviousIndex] = useState(-1);
        const [initialized, setInitialized] = useState(false);
        const MODE_TIMED = "timed";
        const MODE_AUTOPLAY = "autoplay";
        const MODE_USER = "user"
        const slideHolder = useRef(null);

        useEffect(() => {
            console.log("SlideShow useEffect()")
            let slides = slideHolder.current.childNodes;
            let i;
            for (i = 0; i < slides.length; i++) {
                let s = slides[i];
                if (i != slideIndex || selectedSlide) {
                    s.style.opacity = 0;
                }
            }
            console.log("selectedSlide:" + selectedSlide)
            if (selectedSlide) {
                setSlideIndex(getSlideIndex(selectedSlide))
            }
            if (mode == MODE_TIMED) {
                if (data) {
                    initializeAnimations();
                }
            }
            return cleanup;
        }, []);

        useEffect(() => {
            if (mode == MODE_TIMED) return;
            if (mode == MODE_AUTOPLAY) {
                setTimer();
            }
            if (slideIndex == 0 && !initialized) return;
            killSlideTweens();
            if (mode == MODE_USER) {
                for (var i = 0; i < data.slides.length; i++) {
                    if (i == slideIndex) {
                        var slideClass_in = ".SlideShow.slide." + data.slides[i].id;
                        gsap.to(slideClass_in, {opacity: 1, duration: 0.5});
                    } else {
                        var slideClass_out = ".SlideShow.slide." + data.slides[i].id;
                        gsap.to(slideClass_out, {opacity: 0, duration: 0.5});
                    }
                }

            } else {
                var slideClass_out = (previousIndex > -1) ? ".SlideShow.slide." + data.slides[previousIndex].id : "null";
                var slideLocator_out = (previousIndex > -1) ? "#" + (id ? id : "slideshow") + "_" + data.slides[previousIndex].id : "null";
                var slideClass_in = ".SlideShow.slide." + data.slides[slideIndex].id;
                var slideLocator_in = "#" + (id ? id : "slideshow") + "_" + data.slides[slideIndex].id;
                if (document.querySelector(slideClass_out)) {
                    gsap.to(slideLocator_out, {
                        opacity: 0,
                        duration: 0.5,
                        onComplete: (mode == MODE_AUTOPLAY ? setTimer : null)
                    });
                }
                if (document.querySelector(slideClass_in)) {
                    gsap.set(slideLocator_in, {display: "", opacity: 0});
                    gsap.to(slideLocator_in, {opacity: 1, duration: 0.5})
                }
            }

            setInitialized(true)

        }, [slideIndex])

        useEffect(() => {
            console.log("SlideShow selectedSlide updated: selectedSlide:"+selectedSlide);
            if(!selectedSlide) return;
            setSlideIndex(getSlideIndex(selectedSlide));
        }, [selectedSlide]);


        const getSlideIndex = (id) => {
            return _.findIndex(slides, function (o) {
                return o.id == id
            })
        }

        const killSlideTweens = () => {
            try {
                if (slideHolder && slideHolder.current) {
                    let slides = slideHolder.current.childNodes.forEach(s => gsap.killTweensOf(s));
                }
            } catch (e){
                console.log("handled error")
            }
        }

        const cleanup = () => {
            console.log("SLIDESHOW CLEANUP EXECUTING!!");
            killSlideTweens();
        }

        const initializeAnimations = () => {
            let i;
            for (i = 1; i < data.slides.length; i++) {
                var slideClass_in = ".SlideShow.slide." + data.slides[i].id;
                var slideLocator_in = "#" + (id ? id : "slideshow") + "_" + data.slides[i].id;
                gsap.to(slideClass_in, {opacity: 1, duration: 0.5, delay: data.slides[i].delay});
                var slideClass_out = ".SlideShow.slide." + data.slides[i - 1].id;
                var slideLocator_out = "#" + (id ? id : "slideshow") + "_" + data.slides[i - 1].id;
                gsap.to(slideClass_out, {opacity: 0, duration: 0.5, delay: data.slides[i].delay});
            }
        }

        const setTimer = () => {
            let d;
            d = delay ? delay * 1000 : 2000;
            setTimeout(nextSlide, d);
        }

        const nextSlide = () => {
            setPreviousIndex(slideIndex);
            if (nextIndex() < 0) {
                return;
            } else {
                setSlideIndex(nextIndex());
            }
        }

        const nextIndex = () => {
            return (slideIndex + 1 >= data.slides.length) ? (loop ? 0 : -1) : slideIndex + 1;
        }

        return (
            <div ref={slideHolder}
                 id={data.id}
                 style={style ? style : {}}
                 className={`SlideShow ${data.classNames || ''}`}
                 key="slideHolder">
                {data && data.slides.map((slide, index) => (
                    <div
                        id={(id ? id : "slideshow") + "_" + slide.id}
                        key={"slide" + index.toString()}
                        style={style ? {width: style.width} : {}}
                        className={"SlideShow slide " + slide.id}>
                        <img src={slide.url}
                             alt={slide.alt}/>
                    </div>
                ))
                }

            </div>
        );
    }
;

export default SlideShow;